import React, { useEffect, useState } from 'react';
import Product from './Product';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { removeFromCart, updateCartQuantity, clearCart } from '../redux/cartSlice';

const Mens = () => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const { categoryCode, category } = useParams(); // Get the categoryId from the URL
    const [products,setProducts] = useState([]);
    const [productFilter,setProductFilter] = useState([]);
    const [priceFilter, setPriceFilter] = useState('');
    const [brandFilter, setBrandFilter] = useState('');

    const fetchData = async () =>{
        try {
            let url = `${apiBaseUrl}getproducts?category=${categoryCode}`;
            if (priceFilter) {
                url += `&price=${priceFilter}`;
            }
            if (brandFilter) {
            url += `&brands=${brandFilter}`;
            }
            const response = await fetch(url);
            const data = await response.json();
            console.log('result',data)
            setProducts(data.data);
            setProductFilter(data.filters);
            return data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect( () => {
        fetchData();
    },[categoryCode,priceFilter,brandFilter])

    const handlePriceChange = (event) => setPriceFilter(event.target.value);
    const handleBrandChange = (event) => setBrandFilter(event.target.value);

  return (
    <div className='container mt-5'>
        <div className='prod_banner'>

        </div>
        <hr data-content={category.toUpperCase()} className='mb-5 hr-text'/>
        <div className='row'>
            <div className='col-md-6 text-left'>
            </div>
            <div></div>
        </div>
        <div className='row'>
            <div className='col-md-2 mb-3'>
                <h3>Filter</h3>
                <div className='row'>
                    <div className='col-12 mb-3'>
                        <label>Sort By</label>
                        <select onChange={handlePriceChange} value={priceFilter} className='form-control'>
                            <option value="">Sort By</option>
                            <option value="asc">Low to High</option>
                            <option value="desc">High to Low</option>
                        </select>
                    </div>
                    {
                        productFilter?.brand && (<>
                        <div className='col-12 mb-3'>
                            <label>Brand</label>
                            <select onChange={handleBrandChange} value={brandFilter} className='form-control'>
                                <option value="">Brands</option>
                                {
                                    productFilter.brand.map((brands) => (
                                        <option value={brands}>{brands}</option>
                                    ))
                                }
                            </select>
                        </div>
                        </>)
                    }
                    
                </div>
            </div>
            <div className='col-md-10 mb-3 row'>
                {products && products.map((product) => (
                    <Product key={product.id} product={product} />
                ))}
                {
                    !products && (
                        <>
                        <h3 className='text-center'>No Products Available</h3>
                        </>
                    )
                }
            </div>
        </div>
        <div className='row mt-5'>
        {/* <ul class="pagination">
            <li class="icon">
            <a href="#"><span class="fas fa-angle-left"></span>Previous</a>
            </li>
            <li><a href="#">1</a></li>
            <li><a href="#">2</a></li>
            <li><a href="#">3</a></li>
            <li><a href="#">4</a></li>
            <li><a href="#">5</a></li>
            <li><a href="#">6</a></li>
            <li><a href="#">7</a></li>
            <li><a href="#">8</a></li>
            <li><a href="#">9</a></li>
            <li><a href="#">10</a></li>
            <li class="icon">
            <a href="#">Next<span class="fas fa-angle-right"></span></a>
            </li>
        </ul> */}
        </div>
    </div>
  );
}

export default Mens;